import React from "react";

import BodyText from "core/BodyText";
import ResetPasswordViewLink from "../links/ResetPasswordViewLink";
import CodeRequestViewLink from "../links/CodeRequestViewLink";
import DefaultViewLink from "../links/DefaultViewLink";

import { CtaButton, FooterTextStyled, FormInputStyled } from "../styles";

import { useLoginFlow } from "../Context";

import { validNameOrEmail, validPassword } from "../../helpers";

const PasswordLoginView = () => {
    const {
        emailAddress,
        setEmailAddress,
        password,
        setPassword,
        captcha,
        captchaIsValid,
        isProcessing,
        startLoginWithPassword
    } = useLoginFlow();

    return (
        <>
            <FormInputStyled
                name="username"
                autocomplete="username"
                type="text"
                labelText="Email Address"
                placeholderText="yourname@domain.com"
                value={emailAddress}
                onChange={setEmailAddress}
                validation={[
                    {
                        errorMsg: "Please enter a valid email.",
                        isValid: validNameOrEmail
                    }
                ]}
                data-testid="email-address-input"
            />
            <FormInputStyled
                name="password"
                autoComplete="current-password"
                type="password"
                labelText="Password"
                placeholderText="Password"
                value={password}
                onChange={setPassword}
                autoFocus
                validation={[
                    {
                        errorMsg: "Please enter a password.",
                        isValid: validPassword
                    }
                ]}
                data-testid="password-input"
            />
            {captcha}
            <CtaButton
                onClick={e => {
                    e.preventDefault();
                    startLoginWithPassword();
                }}
                isProcessing={isProcessing}
                isDisabled={
                    !(
                        validNameOrEmail(emailAddress) &&
                        validPassword(password) &&
                        captchaIsValid
                    )
                }
            >
                Log In
            </CtaButton>
            <FooterTextStyled>
                <BodyText type="p">
                    Having trouble with password?{" "}
                    <ResetPasswordViewLink>
                        Reset password
                    </ResetPasswordViewLink>
                    , or try{" "}
                    <CodeRequestViewLink>
                        login with one-time code
                    </CodeRequestViewLink>
                    .
                </BodyText>
                <BodyText type="p">
                    <DefaultViewLink>
                        I use Google or Facebook to log in.
                    </DefaultViewLink>
                </BodyText>
            </FooterTextStyled>
        </>
    );
};

export default PasswordLoginView;
